module.exports = __webpack_public_path__ + "static/media/fly0175.d1de83f8.webp";